import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';


function Navigation({ isAuthenticated, LogoutFunc }) {
  return <Navbar expand="lg" className="bg-body-tertiary">
    <Container>
        <Navbar.Brand href="/"><img src={`${process.env.PUBLIC_URL}/Logo.png`} style={{width: "150px"}} alt="ToxDT"></img></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="#docs">Documentation</Nav.Link>
            {isAuthenticated ? <Nav.Link href="/profile/">Profile</Nav.Link> : null}
            {isAuthenticated ? <Nav.Link href="/dashboard/">Dashboard</Nav.Link> : null}
            {isAuthenticated ? <Nav.Link href="#logout" onClick={e=>{e.preventDefault(); LogoutFunc();}}>Logout</Nav.Link> : null}
          </Nav>
        </Navbar.Collapse>
      </Container>
  </Navbar>
}

export default Navigation;